class UtilsService {
  Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
export default new UtilsService();
